import React, { useEffect, useState } from "react";
import { makeStyles} from "@material-ui/core/styles";
import { Button, Card, CardContent,Grid } from "@material-ui/core";
import {Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import Pagination from "@material-ui/lab/Pagination";
import { commonService } from "../../../../services/common.service";
import {store} from "../../../../helpers/store"
import { usageService } from "../service/e_service";
import  Close from "@material-ui/icons/Close";
import { Dialog, DialogContent, DialogActions ,DialogTitle} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import {adminService} from "../../../../services/admin.service";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'; 
import IconButton from "@material-ui/core/IconButton";
import { useMediaQuery } from "react-responsive";
import { useRef } from "react";


const useStyles = makeStyles((theme) => ({
  fontStyle:{
    backgroundColor:theme.palette.ePrimary?.base, 
},
table: {
  borderColor:theme.palette.ePrimary?.base,
  border:2,
  borderStyle:"solid",
  },
  headCell:{
    borderColor:theme.palette.ePrimary?.base,
    border:1,
    borderStyle:"solid",
    fontSize:"0.625rem",
    color: theme.palette.eWhite?.base,
    marginLeft:20,
    marginRight:20
  },
  body:{
    backgroundColor:  theme.palette.ePastelColor2?.base,
  },
  bodyCell:{
    borderColor:theme.palette.ePastelColor2?.base,
    border:2,
    borderStyle:"solid",
    fontSize:"0.625rem",
    marginLeft:20,
    marginRight:20,
    color : theme.palette.ePrimary?.base
  },
  display:{
    display:"flex",
  },
  unitTitle:{
    fontSize:"0.875rem",
    marginTop : 10,
    marginBottom:10
  },
  dialogTitle:{
    color:theme.palette.eWhite?.base,
    backgroundColor:theme.palette.ePrimary?.base,
  },
  crossButton:{
      color: theme.palette.eWhite?.base,
      position: 'absolute',
      right:8,
      top:15
  },
  titleFont:{
    fontSize:"1rem"
  },
  submitButton:{
    backgroundColor:theme.palette.ePrimary?.base,
    color:theme.palette.eWhite?.base,
    borderRadius:30,
    fontSize:"0.875rem",
    '&:hover': {
      backgroundColor: theme.palette.ePrimary?.hover,
    },
    padding: "1% 8%",
  },
  error:{
    width :"100vh",
    height :"20vh"
  },
  listCard:{
    marginRight:10,
    marginTop:10,
    marginBottom:10
  },
  titleStyle:{
      color:theme.palette.eDanger?.dark, 
      fontSize:"0.875rem"   
  },
  bestFor:{
    fontSize:"0.75rem"
  },
  currentPlanTitle:{
    color: theme.palette.ePrimary?.base,
    fontSize:"0.875rem"
  },
  lowestPlanTitle:{
    color:theme.palette.eDanger?.dark,
    fontSize:"0.875rem"
  },
  pagination: {
    marginRight:5,
    marginBottom:5,
    display:"flex",
    flexDirection: "row-reverse"
  },
  contentCenter: {
    marginTop:10,
    marginBottom:10,
    color:theme.palette.eTertiary?.base,
    fontSize:"1.125rem"
  },
  gridPadding:{
    padding:"1%",
  },
  buttonPadding:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop:10,
    marginBottom:10,
    marginLeft:45,  
  },
  image:{
    top : 0,
    left : 0,
    width: "-webkit-fill-available",
  },
  main:{
      marginLeft: 10
  },
  titleMargin:{
      marginBottom:10,
      fontSize:"0.875rem"
  },
  viewDetailsColor: {
    color: theme.palette.eWhite?.base,
    backgroundColor: theme.palette.eSecondary?.base,
    '&:hover': {
      backgroundColor: theme.palette.eSecondary?.hover,
    },
    borderRadius: 30,
  },
  compareButtonColor: {
    color: theme.palette.eWhite?.base,
    backgroundColor: theme.palette.ePrimary?.base,
    '&:hover': {
      backgroundColor: theme.palette.ePrimary?.hover,
    },
    borderRadius: 30,
  },
  margin:{
    marginLeft:10,
    padding:"1%"
  },
  secondButtonPadding:{ 
    marginTop:10,
    marginBottom:10,
    marginLeft:45,  
  },
  compareButtonPadding:{ 
    marginTop:10,
    marginBottom:8,
    marginLeft:45,
  },
  paginationColor:{
    display: "flex",
    justifyContent: "flex-end",
    marginBottom:4,
    "& .MuiPaginationItem-root": {
      color:theme.palette.ePrimary?.base + "!important",
      margin:0
    },
    "& .Mui-selected":{
      backgroundColor:theme.palette.ePrimary?.base + "!important",
      color:theme.palette.eWhite?.base+" !important"
    },
  },
  toTop:{
    borderRadius:50,
    backgroundColor:theme.palette.ePrimary?.base + "!important",
    color:theme.palette.eWhite?.base+" !important",
    padding:"1.4%"
  },
  iconSize:{
    fontSize:"1.2rem"
  },
  mobileImage:{
    top : 0,
    left : 0,
    width: "6vh"
  },
  detailsSubLine:{
    fontSize:"0.75rem"
  },
  fullWidth: {
    width: "100%"
  }
}));

function prepareArrayData(allData){
  let arrayData=[];
  let tempArray=[];
  allData && arrayData.push(allData);
 if(arrayData){
  allData && allData.rates && allData.rates.map((item)=>{
    if(item.isLowestCostRatePlan === "true"){
      arrayData.push(item);
    }
    else{
        tempArray.push(item);
    }
  })
  arrayData=arrayData.concat(tempArray);
 }
  return arrayData;
}

export default function E_CheckboxListSecondary(props) {
  const space = " "
  const customStyle = useStyles();
  const [page, setPage] = useState(1);
  const noOfRows = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_SUSTAINABILITY_ROWS_PER_PAGE);
  const rowsPerPage = parseInt(noOfRows)
  const [tablePageCount, setTablePageCount] = useState();
  let defalutImageForPlan = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_SUSTAINABILITY_CARD_ICON_IMAGE
  );
  const [defaultImagePath, setDefaultImagePath] = useState("");
  useEffect(() => {
    if (defalutImageForPlan) {
      commonService.getAssestUrl(defalutImageForPlan).then((response) => {
        setDefaultImagePath(response);
      });
    }
  }, [defalutImageForPlan]);
  const handlePageChange = (event, newpage) => {
    setPage(newpage);
  };
  const [data,setData] = useState();
  let accountId = useSelector((state) => state?.meterDetails?.accountId);
  let saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
  useEffect(()=>{
    store.getState().snackbar = true;
     if(accountId && saId){
      usageService.getEnergyPlansDetails(saId, accountId)
      .then((response) => {
         setData(response?.data?.getEnergyPlans); 
         setError(false);
         store.getState().snackbar = false;
      })
      .catch((err) =>{
       setError(true);
   });
     }
  },[saId, accountId])
  const [tableArrayData, settableArrayData] = useState();
  useEffect(()=>{
    const array = prepareArrayData(data);
    settableArrayData(array);
    setTablePageCount(Math.ceil((array.length/rowsPerPage)))
  },[data])
  const updateRowData = () =>{
    return tableArrayData?.slice((page-1)*rowsPerPage,(page)*rowsPerPage);
  }
  const finalData = updateRowData();
  const energyPlansListLabels = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_SUSTAINABILITY
  );
 
  const [error,setError] = useState(false);
  const [load,setLoad] = useState(false);
  const [detailsData, setDetailsData] = useState();
  const [rateSchedule, setRateSchedule] = useState();
  useEffect(()=>{
    store.getState().snackbar = true;
    if(accountId && saId && rateSchedule){
      usageService.getEnergyDetailsPage(saId,accountId,rateSchedule)
      .then((response) => {
        setDetailsData(response?.data?.getEnergyPlanDetails);
        setError(false);
      })
      .catch((err) =>{
        setError(true);
    });
    }              
  }, [saId,accountId,rateSchedule,data]);
  const [open, setOpen] = useState(false);
  const handleClickOpen = (rateSchedule) => {
    setOpen(true);
    setRateSchedule(rateSchedule)
  };
  const handleClose = () => {
    setOpen(false);
  };
const [DetailData,setDetailData] = useState();
const [tableData,setTableData] = useState();
useEffect(()=>{
  setDetailData(detailsData);
  setTableData(detailsData?.tables)
},[detailsData])
const [subtitle, setSubTitle] = useState("");
let tenantName = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_NAME);
    let primaryLanguage = useSelector((state) =>state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
    useEffect(() => {
        store.getState().snackbar = true;
        adminService.getContentData(primaryLanguage, "E_SUSTAINABILITY").then((res) => {
          let manageTitle = res?.data?.getContents?.E_SUSTAINABILITY?.[1]?.answer;
          setSubTitle(manageTitle.replaceAll("<TENANT_NAME>", tenantName));
          store.getState().snackbar = false;
        });
    }, [primaryLanguage, tenantName]);
    const MobileHeight = useMediaQuery({ maxWidth: 550 });
    const myRef = useRef(null);
   const executeScroll = () => myRef.current.scrollIntoView();
   const onCompare =(item) =>{
     props.handler(item);
     executeScroll()
   }
  return (
 <>
 {load ===true ? (<>
<Skeleton/>
 </>) : (
   <>
   <Grid className={customStyle.fullWidth} container ref={myRef}>
   <Grid className={customStyle.fullWidth} item >
       <CardContent className={customStyle.main}>
           <Typography align="left" className={customStyle.titleMargin}>
               <b>{energyPlansListLabels?.E_COMPARE_ALL_ENERGY_PLANS}</b>
           </Typography>
       <br/>
   {(typeof(finalData) !== "undefined") && finalData?.map((item,key)=>(
     <>
         {(page===1 && key===0) ? (
           <>
           <Typography
             align="left"
             variant="body2"
             className={customStyle.currentPlanTitle}>
             <b>{energyPlansListLabels?.E_YOUR_CURRENT_PLAN}</b>
           </Typography>
           <Card className={customStyle.listCard}>
             <CardContent>             
             <Grid container direction="row">
                  <Grid item sm={2} className={customStyle.gridPadding}>
                    {MobileHeight ? (
                      <img 
                      className={customStyle.mobileImage}
                      src={defaultImagePath?.assetPath}
                      alt={
                        defaultImagePath
                          ? energyPlansListLabels?.[defaultImagePath?.fallBackLabelKey]
                          :'' } />
                    ):(<img 
                      className={customStyle.image}
                      src={defaultImagePath?.assetPath}
                      alt={
                        defaultImagePath
                          ? energyPlansListLabels?.[defaultImagePath?.fallBackLabelKey]
                          :'' } />) }       
                   </Grid>
                   <Grid item sm={9}  className={customStyle.margin}>
                   <b className={customStyle.titleStyle}>{item.rateScheduleDescription}</b><br/>
                   <span className={customStyle.bestFor}>
                   <b>{energyPlansListLabels?.E_BEST_FOR} :</b> {space}{item?.bestFor}<br/>
                   <b >{energyPlansListLabels?.E_PRICE_HIGHEST} :</b> {space}{item?.priceHighest}
                   </span>
                      <Grid item sm={12} className={customStyle.contentCenter}>
                    <b>{item?.currency}{space}{item?.calculatedAmount}</b>{energyPlansListLabels?.E_YEAR}
                  <br></br>
                  </Grid>  
                   </Grid>                                
               <Grid item sm={6} justify="center" align="center"
               className={customStyle.buttonPadding}
               >
                 <Grid container spacing={1} >
                   <Grid item >
                   <Button
                   className={customStyle.viewDetailsColor}
                     variant="contained"
                     onClick={()=>handleClickOpen(item.rateSchedule)} >
                     <Typography variant="contained" >{energyPlansListLabels?.E_VIEW_DETAILS}</Typography>
                   </Button>
                   </Grid>
                   </Grid>
                   </Grid>                    
             </Grid>              
             </CardContent>
             </Card>
             </>
             ) :(<>
           {item.isLowestCostRatePlan === "true" && ( 
           <Typography
             align="left"
             variant="body2"
             className={customStyle.lowestPlanTitle}
           >
             <b>{energyPlansListLabels?.E_YOUR_LOWEST_COST_PLAN}</b>
           </Typography>
           )}

           <Card className={customStyle.listCard}>
             <CardContent>             
             <Grid container direction="row">
                 <Grid item sm={2} className={customStyle.gridPadding}>
                 {MobileHeight ? (
                      <img 
                      className={customStyle.mobileImage}
                      src={defaultImagePath?.assetPath}
                      alt={
                        defaultImagePath
                          ? energyPlansListLabels?.[defaultImagePath?.fallBackLabelKey]
                          :'' } />
                    ):(<img 
                      className={customStyle.image}
                      src={defaultImagePath?.assetPath}
                      alt={
                        defaultImagePath
                          ? energyPlansListLabels?.[defaultImagePath?.fallBackLabelKey]
                          :'' } />) } 
                   </Grid>
                   <Grid item sm={9} className={customStyle.margin}>
                   <b className={customStyle.titleStyle}>{item.rateScheduleDescription}</b><br/>
                  <span className={customStyle.bestFor}>
                  <b>{energyPlansListLabels?.E_BEST_FOR} :</b> {space}{item?.bestFor}<br/>
                   <b>{energyPlansListLabels?.E_PRICE_HIGHEST} :</b> {space}{item?.priceHighest}
                  </span>
                  <Grid item sm={12} className={customStyle.contentCenter}>
                 <b>{item?.currency}{space}{item?.calculatedAmount}</b>{energyPlansListLabels?.E_YEAR}
               </Grid>
                   </Grid>   
               <Grid item sm={12} >
                 <Grid container spacing={1}>
                   <Grid item className={customStyle.secondButtonPadding}>
                   <Button
                      className={customStyle.viewDetailsColor}
                     variant="contained"
                     onClick={()=>handleClickOpen(item.rateSchedule)} >
                     <Typography variant="body2">{energyPlansListLabels?.E_VIEW_DETAILS}</Typography>
                   </Button>
                         <Dialog onClose={handleClose} open={open}> 
                         <DialogTitle className={customStyle.dialogTitle}><Typography className={customStyle.titleFont}>{energyPlansListLabels?.E_TARIFF_PLAN_DETAILS} </Typography>  <Button startIcon={<Close />} onClick={handleClose} className={customStyle.crossButton}></Button>
                         </DialogTitle>
                         <DialogContent dividers>
                           <Typography className={customStyle.detailsSubLine}
                           dangerouslySetInnerHTML={{
                             __html: subtitle,
                           }}
                           >
                           </Typography>
                         <Grid item>
                         {tableData ? (<>
                   {tableData?.map((eachTable)=>{
                       return(<>
                   <Typography className={customStyle.unitTitle}><b>{eachTable.title} {DetailData?.units}</b></Typography>                  
                       <div className={customStyle.display} align="center">
                       {eachTable?.data?.map((row)=>{
                           return(                           
                            <div className={customStyle.table}  >
                            <div colSpan={3} className={customStyle.fontStyle}>
                              <div align="center" className={customStyle.headCell}>{row.key}</div>
                              </div>
                             <div className={customStyle.body}>  
                               <div  className={customStyle.bodyCell} align="center">{commonService.Numberwithcommas(Number(parseFloat(row.value)).toFixed(2))}</div> 
                              </div>                             
                            </div> 
                           ) } )}
                     </div>
               </> ) }
                )} 
              </>):(<><Skeleton/></>)}
               </Grid> 
                         </DialogContent>
                       <DialogActions>
                         <Button autoFocus onClick={handleClose} className={customStyle.submitButton}>
                         {energyPlansListLabels?.E_OK}
                         </Button>
                       </DialogActions>
                         </Dialog>
                   </Grid>
                   <Grid item className={customStyle.compareButtonPadding}>
                   <Button
                     className={customStyle.compareButtonColor}
                     variant="contained"
                     onClick={()=> {onCompare(item)}}
                   >
                     <Typography variant="body2">{energyPlansListLabels?.E_COMPARE}</Typography>
                   </Button>
                   </Grid>
                   </Grid>
                   </Grid>                    
             </Grid>
             </CardContent>
             </Card>
         </>)
         }
     </>
   ))}
                {tablePageCount > 1 &&  (  
                <Grid className={customStyle.pagination} direction="rows"> 
                <IconButton className={customStyle.toTop} onClick={executeScroll}><ArrowUpwardIcon className={customStyle.iconSize}/> </IconButton>
                <Pagination
                   count={tablePageCount}
                   page={page}
                   onChange={handlePageChange}
                   className={customStyle.paginationColor}
                 />
                 </Grid>
                  )}
    </CardContent>
   </Grid>
   </Grid>
   </>
 )}
 </>
  );
}